import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { debounceTime } from "rxjs/operators";
import { LedgerService } from "../../master/ledger/shared/ledger.service";
import { OpbalanceserviceService } from "../shared/opbalanceservice.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Voucher } from '../voucher/shared/voucher.model';
// import { Ledgerentries } from 'src/app/master/ledger/shared/ledgerentries.model';
import { Ledgerentries } from "./../../master/ledger/shared/ledgerentries.model";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-openingbalance',
  templateUrl: './openingbalance.component.html',
  styleUrls: ['./openingbalance.component.css']
})

export class OpeningbalanceComponent implements OnInit {

  searchTerm: FormControl = new FormControl();
  addOPBalanceForm: FormGroup;
  LedgerList: any = [];
  AddButtonText: string;
  ErrorText: string;
  TransactionNo: number;

  displayedColumns: string[] = ['LedgerName', 'Debit', 'Credit'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private formBuilder: FormBuilder, private ledgerService: LedgerService,
    private opbalanceserviceService: OpbalanceserviceService,
    private commonmastersService: CommonmastersService,
    private router: Router, private datePipe: DatePipe,) {

    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.AddButtonText = "Save";

    this.addOPBalanceForm = this.formBuilder.group({
      frmId: [0],
      frmLedgerName: ['', Validators.required],
      frmLedgerNo: [],
      frmDebit: [0.00],
      frmCredit: [0.00],
      frmActive: [true],
      frmTransactionDate: [JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]],
      frmTransactionId: [],
      frmFlag: [1],
    });

    this.GetAutogeneratedNumber();
    this.onChanges();

    this.getLedgerList();
    this.dataSource.paginator = this.paginator;

    // this.opbalanceserviceService.selectedVoucher.Ledgerentries =new Ledgerentries;
  }

  onChanges(): void {

    this.addOPBalanceForm.get("frmLedgerName").valueChanges.pipe(debounceTime(700)).subscribe(val => {
      if (val != '') {
        this.ledgerService.FetchLedgerByNames(val).subscribe(
          data => {
            this.LedgerList = data as any[];
          }
        )
      }
    });
  }

  public onSubmit() {

    this.ErrorText = "";

     //----------------------------------------------------    
     this.opbalanceserviceService.ledgerentries.Id = 0;   // not required for OP balance   
     this.opbalanceserviceService.ledgerentries.LedgerId =  this.LedgerList.find(item => item.SubLedgerName == this.addOPBalanceForm.value.frmLedgerName).Id
     this.opbalanceserviceService.ledgerentries.TransactionId = this.TransactionNo;
     // this.opbalanceserviceService.selectedVoucher.Ledgerentries.EntryType = this.ledgerArray[i].EntryType;
     this.opbalanceserviceService.ledgerentries.Particulars = this.addOPBalanceForm.value.frmLedgerName;
 
     if (this.addOPBalanceForm.value.frmDebit != 0) {
       this.opbalanceserviceService.ledgerentries.EntryType =  "D";;
       this.opbalanceserviceService.ledgerentries.Amount = this.addOPBalanceForm.value.frmDebit;
     }
     else {
       this.opbalanceserviceService.ledgerentries.EntryType = "C";
       this.opbalanceserviceService.ledgerentries.Amount = this.addOPBalanceForm.value.frmCredit;
     }
 
     this.opbalanceserviceService.ledgerentries.CreatedDate = this.addOPBalanceForm.value.frmTransactionDate;
     this.opbalanceserviceService.ledgerentries.TransactionId = this.TransactionNo;
     this.opbalanceserviceService.ledgerentries.Remarks = "Opening Balance" ;

 
  //  this.opbalanceserviceService.selectedVoucher.Id =0;  // not required for OP balance
  //  this.opbalanceserviceService.selectedVoucher.VoucherNumber =  this.addOPBalanceForm.value.frmTransactionId;
  //  this.opbalanceserviceService.selectedVoucher.VoucherTypeId = 1;  // keep it cash for OP balance
  //  this.opbalanceserviceService.selectedVoucher.VoucherAmount = this.opbalanceserviceService.selectedVoucher.Ledgerentries.Amount ;
  //  this.opbalanceserviceService.selectedVoucher.VoucherTotalDebit =  this.addOPBalanceForm.value.frmDebit;
  //  this.opbalanceserviceService.selectedVoucher.VoucherTotalCredit =  this.addOPBalanceForm.value.frmDebit;
  //  this.opbalanceserviceService.selectedVoucher.Narration = "Opening Balance entry"
  //  this.opbalanceserviceService.selectedVoucher.VoucherDate = this.addOPBalanceForm.value.frmTransactionDate;
  //  this.opbalanceserviceService.selectedVoucher.ApprovalStatusId = 1;
  //  this.opbalanceserviceService.selectedVoucher.ReceiptTypeId = 1; // need to change
   // var isoDate = new Date().toISOString()

   const curr_date = new Date(this.opbalanceserviceService.ledgerentries.CreatedDate);

   if(curr_date.getDate() != 1 || curr_date.getMonth() + 1 != 4){
     this.ErrorText = "Please change Financial date";
     this.ngOnInit();
     return;
   }
 
   this.opbalanceserviceService.IUDOpbalance(this.opbalanceserviceService.ledgerentries)
     .toPromise()
     .then(data => {
       this.ngOnInit();
     })
     .catch(err => { console.log(err) });

    // console.log(this.addOPBalanceForm.value.frmDebit);
    // console.log("c");
    // console.log(this.addOPBalanceForm.value.frmCredit);

    // this.addOPBalanceForm.value.frmTransactionId = this.TransactionNo;
    // if (this.addOPBalanceForm.value.frmDebit == this.addOPBalanceForm.value.frmCredit
    //   ||
    //   ((this.addOPBalanceForm.value.frmDebit != 0) && (this.addOPBalanceForm.value.frmCredit != 0))
    //   || 
    //   ((this.addOPBalanceForm.value.frmDebit > 0) && (this.addOPBalanceForm.value.frmCredit > 0))
    // ) {

    //   // this.ErrorText = "Dr. and Cr. should not be equal or empty"
    //   this.ErrorText = "Wrong entry."
    //   return;
    // }

    
    // this.opbalanceserviceService.ledgerentries.LedgerId =  this.LedgerList.find(item => item.SubLedgerName == this.addOPBalanceForm.value.frmLedgerName).Id
    // // this.opbalanceserviceService.ledgerentries.LedgerId = this.addOPBalanceForm.value.frmLedgerName;

    // if (this.addOPBalanceForm.value.frmDebit != 0) {
    //   this.opbalanceserviceService.ledgerentries.EntryType = "D";
    //   this.opbalanceserviceService.ledgerentries.Amount = this.addOPBalanceForm.value.frmDebit;
    // }
    // else {
    //   this.opbalanceserviceService.ledgerentries.EntryType = "C";
    //   this.opbalanceserviceService.ledgerentries.Amount = this.addOPBalanceForm.value.frmCredit;
    // }

    // this.opbalanceserviceService.ledgerentries.CreatedDate = this.addOPBalanceForm.value.frmTransactionDate;
    // this.opbalanceserviceService.ledgerentries.TransactionId = this.addOPBalanceForm.value.frmTransactionId;
    // this.opbalanceserviceService.ledgerentries.Remarks = "From OP Balance";
    // this.opbalanceserviceService.ledgerentries.Isopening = true;

    // //   // var isoDate = new Date().toISOString()
    // //   console.log( this.voucherService.selectedVoucher);

    // this.opbalanceserviceService.IUDOpbalance(this.opbalanceserviceService.ledgerentries)
    //   .toPromise()
    //   .then(data => {
    //     // this.router.navigate(['/Openingbalance']);
    //     this.ngOnInit();
    //   })
    //   .catch(err => { console.log(err) });

    // this.ClearFormValues();
    // this.GetAutogeneratedNumber();
    // this.onChanges();    
  }

  GetAutogeneratedNumber(): any {
    const TransactionNo = this.commonmastersService.FetchAutogeneratedNumber()
      .toPromise()
      .then(res => {
        this.TransactionNo = res[0].AutoGeneratedId;
        // this.addOPBalanceForm.value.frmTransactionId = res[0].AutoGeneratedId;
        return Promise.resolve(res[0].AutoGeneratedId);
      })
      .catch(err => { console.log(err) });
  }

  ClearFormValues() {
    this.addOPBalanceForm = this.formBuilder.group({
      frmId: [0],
      frmLedgerName: ['', Validators.required],
      frmLedgerNo: [],
      frmDebit: [],
      frmCredit: [],
      frmActive: [true],
      frmTransactionDate: [JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]],
      frmTransactionId: [],
      frmFlag: [1],
    });
  }

  getLedgerList() {
    this.opbalanceserviceService.FetchLedgerEntriesList().subscribe(data => {
      // this.ChequeList$=data;
      this.dataSource = data;
    })
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
